import { useAppStore } from '@/stores/app';

interface NuxtContext {
	route: import('vue-router').Route;
	[key: string]: any;
}

/**
 * Middleware che carica le risorse necessarie per ogni route
 * Salva i metadati della route nello store per utilizzarli in componenti come Breadcrumb
 *
 * Usa direttamente Pinia - migrazione completata
 *
 * @param context - Contesto Nuxt con route
 */
export default function loadResources(context: NuxtContext): void {
	const { route } = context;

	try {
		// Usa direttamente il composable Pinia
		const appStore = useAppStore();
		appStore.setMeta(route.meta);
	} catch (error) {
		console.error('❌ ERROR loadResources middleware:', error);
		// Non bloccare la navigazione se c'è un errore nello store
	}
}
